const state = {
  saveAsFileMap: {}, //已经下载文件列表,key:fileId,value:filePath
};

const mutations = {
  addFileMap: (state, { fileId, filePath }) => {
    state.saveAsFileMap[fileId] = filePath;
  },
  delFileMap: (state, fileId) => {
    delete state.saveAsFileMap[fileId];
  },
};

export default {
  namespaced: true,
  state,
  mutations,
};
